/** Reads a file chosen in a form as a data URL, for the picture previews. */
export const readAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () =>
      reject(new Error('Failed to read the file', { cause: reader.error }));
    reader.readAsDataURL(file);
  });
